// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueI18n from 'vue-i18n'

Vue.config.productionTip = false
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: "en", // set default locale
  messages: {
    "de": {
      "pageagenda.calenderView": "Kalenderansicht ändern:",
      "pageagenda.calenderViewLarger": "Größer",
      "pageagenda.calenderViewSmaller": "Kleiner",
      "pageagenda.calenderViewLegend": "Legende",
      "pageagenda.calenderViewOClock": "Uhr",
      "pageagenda.calenderViewAddToCalendar": "Zum Kalender hinzufügen",
    },
    "en": {
      "pageagenda.calenderView": "Change calendar view:",
      "pageagenda.calenderViewLarger": "Larger",
      "pageagenda.calenderViewSmaller": "Smaller",
      "pageagenda.calenderViewLegend": "Legend",
      "pageagenda.calenderViewOClock": "o'clock",
      "pageagenda.calenderViewAddToCalendar": "Add to calendar",
    }
  },
});

/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js